module.exports = __webpack_public_path__ + "static/media/city.362e363e.svg";